<template>
  <div>
    <alert-detail-dialog :dialog="dialog" @toggleD="toggleDialog" :alert="activeAlert">
    </alert-detail-dialog>
    <Card>
      <Toolbar>
        <v-toolbar-title class="body-2">{{ $t('Alert') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="hidden-sm-and-down">
          <v-chip small outline class="cursor--pointer primaryText--text" color="primaryText"
            @click.native="changeSortOrder">
            <v-avatar>
              <v-icon color="primaryText">import_export</v-icon>
            </v-avatar>
            {{ $t(sortBY) }} -
            {{ isAsc ? $t('ASC') : $t('DESC') }}
          </v-chip>
          <v-chip small outline color="primaryText">
            <v-avatar>
              <v-icon color="primaryText">date_range</v-icon>
            </v-avatar>
            {{ date.from }} -
            {{ date.to }}
          </v-chip>
        </div>
        <v-spacer></v-spacer>
        <text-input-field v-model="searchText" :placeholder="$t('Search')"></text-input-field>
        <v-btn icon @click="download">
          <v-icon color="primaryText">get_app</v-icon>
        </v-btn>
        <v-btn icon @click="openCreateDialog = true">
          <v-icon>add</v-icon>
        </v-btn>
      </Toolbar>
      <div>
        <div class="pb-2 hidden-md-and-up bar-bg elevation-4">
          <v-chip small outline color="primaryText" class="cursor--pointer primaryText"
            @click.native="changeSortOrder">
            <v-avatar>
              <v-icon color="primaryText">import_export</v-icon>
            </v-avatar>
            {{ sortBY }} -
            {{ isAsc ? 'ASC' : 'DESC' }}
          </v-chip>
          <v-chip small outline color="primaryText">
            <v-avatar>
              <v-icon color="primaryText">date_range</v-icon>
            </v-avatar>
            {{ date.from }} -
            {{ date.to }}
          </v-chip>
        </div>
        <v-layout justify-center row wrap class="ma-0 pa-2 alert-container-height">
          <v-flex v-show="isLoading" :class="{'d-flex' : isLoading}" xs12>
            <v-spacer />
            <v-progress-circular v-show="isLoading" :size="50" color="primary" indeterminate />
            <v-spacer />
          </v-flex>

          <div v-if="!getTotalAlert && !isLoading">{{ $t('No Data') }}</div>
          <v-flex v-else xs12>
            <alert-card v-for="item in visibleData" :key="item.ref_id" :item="item"
              @click="dialog=true; activeAlert=item"></alert-card>
          </v-flex>
        </v-layout>
      </div>
      <div class="pa-2 footer-bg">
        <v-layout align-center justify-space-between row wrap>
          <v-flex order-xs2 order-md1 shrink class="primaryText--text">
            <span class="alert-count caption"><span class="alert-legend error"></span>
              {{ $t('New') }}
            </span>
            <span class="alert-count caption">
              <span class="alert-legend warning"></span>
              {{ $t('Acknowledge') }}
            </span>
            <span class="alert-count caption">
              <span class="alert-legend success"></span>
              {{ $t('Resolved') }}
            </span>
          </v-flex>
          <v-flex order-xs1 order-md2 shrink :ml-auto="$vuetify.breakpoint.smAndDown"
            :mr-auto="$vuetify.breakpoint.smAndDown">
            <span class="primaryText--text">{{itemFrom}} - {{itemTo}} of {{getTotalAlert}}</span>
            <span class="action">
              <v-btn avatar fab small :disabled="!hasPrevious" class="fab-btn-xs" @click="previous">
                <v-icon>navigate_before</v-icon>
              </v-btn>
              <v-btn avatar fab small :disabled="!hasNext" class="fab-btn-xs" @click="next">
                <v-icon>navigate_next</v-icon>
              </v-btn>
            </span>
          </v-flex>
        </v-layout>
      </div>
    </Card>
    <CreateAlert :open="openCreateDialog" @change:state="value => {openCreateDialog = value}" />
  </div>
</template>

<script>
const momentTz = require('moment-timezone')
import TextInputField from '@/components/utility/TextInputField'
import AlertDetailDialog from '@/components/Alert-v2/AlertDetailDialog'
import AlertCard from '@/components/Alert-v2/AlertCard'
import CreateAlert from '@/components/Alert-v2/CreateAlert'
import {
  mapGetters
} from 'vuex'

import {
  EventBus
} from '@/services/event-bus'

import { timezoneMixin, filterMixin } from '@/util/mixin/index'

export default {
  mixins: [ timezoneMixin, filterMixin ],
  props: {
    itemPerPage: {
      type: Number
    }
  },
  components: {
    TextInputField,
    AlertDetailDialog,
    AlertCard,
    CreateAlert
  },
  data() {
    return {
      dialog: false,
      openCreateDialog: false,
      activeAlert: {},
      searchText: '',
      page: 1,
      isAsc: false
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getGeneralState', 'getActivePlantInfo']),
    ...mapGetters('alert', ['getAlerts', 'getTotalAlert', 'isLoading']),
    activeFilter() {
      return this.getGeneralState('activeFilterOption')
    },
    sortBY() {
      return this.activeFilter && this.activeFilter.sortBy ? this.activeFilter.sortBy.text : 'created_timestamp'
    },
    date() {
      return this.activeFilter && this.activeFilter.Date ? this.activeFilter.Date : {
        from: momentTz().tz(this.getActivePlantInfo("timezone")).format('YYYY-MM-DD'),
        to: momentTz().tz(this.getActivePlantInfo("timezone")).format('YYYY-MM-DD')
      }
    },
    alertData() {
      let data = Object.values(this.getAlerts)
      if (this.searchText !== '') {
        data = data.filter(item => {
          return item.code.includes(this.searchText) || (item.name && item.name.includes(this.searchText)) || item.message.includes(this.searchText)
        })
      }

      return data.sort((a, b) => {
        // a should come before b in the sorted order
        let sortBy = null
        if (this.activeFilter && !this.activeFilter.sortBy) {
          sortBy = 'created_timestamp'
        } else {
          sortBy = this.activeFilter.sortBy.value
        }
        if (a[sortBy] < b[sortBy]) {
          return this.isAsc ? -1 : 1
          // a should come after b in the sorted order
        } else if (a[sortBy] > b[sortBy]) {
          return this.isAsc ? 1 : -1
          // and and b are the same
        } else {
          return 0
        }
      })
    },
    totalDeviceAlert() {
      // TOTAL NUMBER OF DEVICE ON
      let counts = {}
      let deviceOn = this.alertData
      deviceOn.forEach((element, index) => {
        if (!counts[element.alertStatus]) {
          counts[element.alertStatus] = 0
        }
        counts[element.alertStatus] += 1
      })
      return counts
    },
    itemFrom() {
      if (this.page === 1 && this.getTotalAlert > 0) {
        return 1
      }
      return (this.page - 1) * this.itemPerPage
    },
    itemTo() {
      if ((this.page * this.itemPerPage) > this.getTotalAlert) {
        return this.getTotalAlert
      }
      return this.page * this.itemPerPage
    },
    isNext() {
      return this.page * 10 < this.getTotalAlert
    },
    visibleData() {
      return this.alertData.length === 0 ? [] : this.alertData.map(el => {
        if (el.created_time) {
          el.created_time = this.timezoneTime(el.created_time)
        }
        if (el.resolved_time) {
          el.resolved_time = this.timezoneTime(el.resolved_time)
        }
        return el
      })
    },
    hasNext() {
      return this.itemTo < this.getTotalAlert
    },
    hasPrevious() {
      return this.itemFrom > 1
    }
  },
  methods: {
    fetchAlertData() {
      EventBus.$emit('alertPageNum', this.page)
    },
    download() {
      EventBus.$emit('alertDownload')
    },
    toggleDialog(value) {
      this.dialog = value
    },
    changeSortOrder() {
      this.isAsc = !this.isAsc
    },
    previous() {
      if (this.page > 1) this.page -= 1
    },
    next() {
      if (this.isNext) this.page += 1
    }
  },
  watch: {
    page: function() {
      this.fetchAlertData()
    }
  }
}
</script>

<style>
  .cursor--pointer {
    cursor: pointer;
  }

  </style>
<style scoped>
.fab-btn-xs {
    height: 20px;
    width: 20px;
  }

  .truncate {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .alert-label {
    border-left: 15px;
    border-right: 0px;
    border-top: 0px;
    border-bottom: 0px;
    /* border-color: green; */
    border-style: solid;
  }

  .alert-label-err {
    border-color: var(--v-error-base);
  }

  .alert-label-ack {
    border-color: var(--v-warning-base);
  }

  .alert-label-success {
    border-color: var(--v-success-base);
  }

  .alert-count {
    /* color: #fff; */
    align-items: center;
    margin: 0 10px;
    font-weight: bold;
  }

  .alert-legend {
    width: 12px;
    height: 12px;
    /* background-color: #DE625A; */
    border-radius: 50%;
    display: inline-block;
    margin-right: 6px;
  }

  .alert-container-height {
    height: 650px;
    max-height: 650px;
    overflow-y: scroll;
  }

  /* .theme--light .alert-text-color {
    color: #6a7a8c;
  }

  .theme--dark .alert-text-color {
    color: #b2b9bf;
  } */

  .bg-alert-list {
    align-items: center;
    border-radius: 10px;
  }

  .theme--dark .bg-alert-list:hover {
    z-index: 200;
    /* background-color: #252C3E !important; */
    -webkit-transform: translateY(-4px);
    transform: translateY(-4px);
  }

  .theme--light .bg-alert-list:hover {
    z-index: 200;
    /* background-color: #cccccc !important; */
    -webkit-transform: translateY(-4px);
    transform: translateY(-4px);
  }

  /* .theme--dark .bg-alert-list {
    background-color: #1D2336;
  }

  .theme--light .bg-alert-list {
    background-color: #FBFBFB;
  } */

  .alert-title {
    display: flex;
    align-items: center;
  }

  .alert-name {
    font-size: 16px;
    font-weight: bold;
  }

  /* .theme--light .alert-name {
    color: #6a7a8c;
  }

  .theme--dark .alert-name {
    color: #b2b9bf;
  } */

  .alert-badge {
    border-radius: 6px;
    font-size: 12px;
    padding: 2px 6px;
    margin: 0 8px;
    text-transform: uppercase;
  }
</style>
